import type { SystemListBand } from 'app/types/navigation'
import { ACTION_QUEUE_BY_ID, activeLeadsSearchTerms } from 'app/components/action-center/queueRegistry'

/** A window somebody typed a day count for: `last:7` is the leads who joined in the last 7 days. */
const DAY_WINDOW = /^last:([1-9]\d{0,3})$/

/** A typed day window as an Active Leads band, for the list's table and board. */
export function leadDayWindowBand(param: string): SystemListBand | undefined {
  const match = DAY_WINDOW.exec(param)
  const anchor = ACTION_QUEUE_BY_ID.get(`active-leads`)
  if (!match || !anchor) return undefined
  const days = Number(match[1])
  const label = `Last ${days} days`
  return {
    id: param,
    label,
    queue: { ...anchor, shortName: label, searchTerms: (opts) => activeLeadsSearchTerms(days, opts) },
  }
}
